// Bootstrap components
// require('./bootstrap/alert');
// require('./bootstrap/base-component');
// require('./bootstrap/button');
// require('./bootstrap/carousel');
// require('./bootstrap/collapse');
require('./bootstrap/modal');
// require('./bootstrap/offcanvas');
// require('./bootstrap/scrollspy');
// require('./bootstrap/tab');
// require('./bootstrap/toast');

// Run `npm install --save @popperjs/core` from the project root to utilize the following bootstrap components
// require('./bootstrap/dropdown');
// require('./bootstrap/popover');
// require('./bootstrap/tooltip');

$('[data-toggle="modal"]').on('click', function (e) {
    e.preventDefault();
    let target = $(this).data('target');
    $(target).modal('show');
});

$('.modal .close').on('click', function () {
    // find iframe and pause it by swapping url with the same url without autoplay on
    let iframe = $(this).closest('.modal').find('iframe');
    if(iframe.length) {
        let iframeSrc = iframe.attr('src');
        iframe.attr('src', iframeSrc.replace('?autoplay=1', ''));
    }

    $(this).closest('.modal').modal('hide');
});

$('.modal').on('shown.bs.modal', function () {

    // find iframe and play it by swapping url with the same url with autoplay on
    let iframe = $(this).find('iframe');
    if(iframe.length) {
        let iframeSrc = iframe.attr('src');
        if(iframeSrc.indexOf('?') > -1) {
            // already has query string
            if(iframeSrc.indexOf('autoplay=1') === -1) {
                iframe.attr('src', iframeSrc + '&autoplay=1');
            }
        } else {
            iframe.attr('src', iframeSrc + '?autoplay=1');
        }
    }

    let videoObject = $(this).find('video');
    if(videoObject.length) {
        videoObject.get(0).play();
    }

});

$(".modal").on('hidden.bs.modal', function () {
    // find iframe and pause it by swapping url with the same url without autoplay on
    let iframe = $(this).find('iframe');
    if(iframe.length) {
        let iframeSrc = iframe.attr('src');
        iframe.attr('src', iframeSrc.replace('?autoplay=1', ''));
    }

    let videoObject = $(this).find('video');

    if(videoObject.length) {
        videoObject.get(0).pause();
    }

});
